



































import { computed, defineComponent, Ref, ref, toRefs } from '@vue/composition-api';
import { CopyBannerErrorType } from '@tt4b/ttam-enums';
import { PropType } from 'vue';
import { i18n } from '@tt4b/ttam-i18n';

const name = 'ttam-creative-copy-alert';

export default defineComponent({
  name,
  props: {
    errorMap: {
      type: Object as PropType<Record<CopyBannerErrorType, []>>,
      default: () => ({}),
    },
  },
  setup(props) {
    const { errorMap } = toRefs(props);
    const curMoreActive = ref(true);
    const errorArr = computed(() => {
      const arr = [];
      Object.keys(errorMap.value).forEach(key => {
        errorMap.value[key].forEach(item => {
          arr.push(item);
        });
      });
      return arr;
    });
    const alertTitle = computed(() => {
      const len = errorArr.value.length;
      if (len === 1) {
        return errorArr.value[0];
      } else {
        return i18n.t('module_copy_creative_alert_title', { 0: len });
      }
    });
    return {
      name,
      curMoreActive,
      errorArr,
      alertTitle,
    };
  },
});
